export const PROJECT_ENV: string | undefined = process.env.REACT_APP_SERVER_ENV

const API_BASE_URL_MAP: any = {
  develop: 'http://confer-dev.jlgltech.com/api/v1',
  production: 'https://confer.jlgltech.com/api/v1',
  rc: 'https://confer-rc.jlgltech.com/api/v1',
  fat: 'https://confer-fat.jlgltech.com/api/v1',
}

export const API_BASE_URL: string = API_BASE_URL_MAP[PROJECT_ENV || 'develop']

// sso 域名
const ssoPageYuMing: any = {
  develop: 'https://sso.jiliguala.com',
  production: 'https://sso.jiliguala.com',
  fat: 'https://sso.jiliguala.com',
  rc: 'https://sso.jiliguala.com',
}
export const ssoLoginUrl = `${ssoPageYuMing[PROJECT_ENV || 'develop']}/login`
